module.exports = __webpack_public_path__ + "static/media/5DPO9.d9dffa2e.jpg";